/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256.365 3C116.645 3 3 116.673 3 256.365c0 25.82 3.886 51.303 11.488 75.716 3.492 11.123 15.29 17.317 26.469 13.854 11.122-3.492 17.345-15.318 13.854-26.468-6.364-20.33-9.574-41.561-9.574-63.102 0-116.405 94.695-211.128 211.128-211.128 116.433 0 211.128 94.723 211.128 211.128 0 116.433-94.695 211.156-211.128 211.156-50.825 0-98.637-17.683-136.707-50.206l171.313-171.538-4.759 58.23c-.985 11.63 7.66 21.823 19.288 22.809.592.028 1.183.056 1.774.056 10.841 0 20.077-8.335 21.006-19.4l9.517-115.56c.507-6.167-1.717-12.278-6.11-16.642-4.364-4.393-10.56-6.617-16.67-6.138l-115.616 9.489c-11.629.957-20.273 11.15-19.316 22.751.93 11.63 10.897 20.105 22.78 19.345l58.23-4.787L74.408 402.842c-8.137 8.138-8.25 21.316-.253 29.594 48.15 49.84 112.857 77.322 182.21 77.322 139.72 0 253.364-113.674 253.364-253.393C509.73 116.673 396.084 3 256.365 3z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconPromote = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconPromote.defaultProps = {
  theme,
};
IconPromote.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconPromote.displayName = 'IconPromote';
export { IconPromote };
